import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, ErrorApi, fijarAccessToken } from '../lib/api.ts';
import { CLAVE_SESION } from '../lib/sesion.ts';
import { Aviso, Boton, Campo } from '../componentes/ui.tsx';

/** Cambio forzado de clave en el primer ingreso (D10). */
export function PaginaCambiarClave() {
  const { t } = useTranslation();
  const navegar = useNavigate();
  const qc = useQueryClient();

  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetida, setRepetida] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function guardar(evento: React.FormEvent) {
    evento.preventDefault();
    setError(null);

    if (nueva.length < 8) return setError(t('clave.minimo'));
    if (nueva !== repetida) return setError(t('clave.noCoinciden'));

    setEnviando(true);
    try {
      const resp = await api<{ accessToken: string }>('/auth/change-password', {
        metodo: 'POST',
        cuerpo: { passwordActual: actual, passwordNueva: nueva },
      });
      fijarAccessToken(resp.accessToken);
      await qc.invalidateQueries({ queryKey: CLAVE_SESION });
      await navegar({ to: '/' });
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : t('login.errorGenerico'));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center py-6">
      <form
        onSubmit={guardar}
        className="tarjeta w-full max-w-md space-y-4 p-8"
      >
        <h1 className="text-[30px] font-light">
          {t('clave.titulo')}
        </h1>
        <p className="text-sm text-suave">{t('clave.explicacion')}</p>

        <Campo
          etiqueta={t('clave.actual')}
          type="password"
          autoComplete="current-password"
          value={actual}
          onChange={(e) => setActual(e.target.value)}
          required
        />
        <Campo
          etiqueta={t('clave.nueva')}
          type="password"
          autoComplete="new-password"
          value={nueva}
          onChange={(e) => setNueva(e.target.value)}
          required
        />
        <Campo
          etiqueta={t('clave.repetir')}
          type="password"
          autoComplete="new-password"
          value={repetida}
          onChange={(e) => setRepetida(e.target.value)}
          required
        />

        {error ? <Aviso>{error}</Aviso> : null}

        <Boton type="submit" className="w-full" disabled={enviando}>
          {t('clave.guardar')}
        </Boton>
      </form>
    </main>
  );
}
